import React, { useState } from 'react';

const ListModule = ({ data, config }) => {
  const listType = config.type || 'default';
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelect = (item) => {
    if (config.selectable) {
      setSelectedItems(prev =>
        prev.includes(item)
          ? prev.filter(i => i !== item)
          : [...prev, item]
      );
    }
  };

  const listTypes = {
    default: 'list-disc',
    numbered: 'list-decimal',
    bulleted: 'list-disc',
    checkable: 'list-none'
  };

  return (
    <div className={`space-y-2 ${listTypes[listType]}`}>
      {data.map((item, index) => (
        <div
          key={index}
          onClick={() => handleSelect(item)}
          className={`p-3 rounded-lg border theme-border-secondary cursor-pointer transition-colors ${
            config.selectable ? 'hover:theme-bg-secondary' : ''
          } ${selectedItems.includes(item) ? 'bg-primary-50 border-primary-200' : ''}`}
        >
          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-medium theme-primary">
                {typeof item.title === 'object' ? JSON.stringify(item.title) : 
                 typeof item.title === 'string' || typeof item.title === 'number' ? item.title : 
                 typeof item.name === 'object' ? JSON.stringify(item.name) : 
                 typeof item.name === 'string' || typeof item.name === 'number' ? item.name : 'Untitled'}
              </h4>
              <p className="text-sm theme-secondary">
                {typeof item.description === 'object' ? JSON.stringify(item.description) : 
                 typeof item.description === 'string' || typeof item.description === 'number' ? item.description : ''}
              </p>
            </div>
            {item.badge && (
              <span className="px-2 py-1 bg-primary-100 text-primary-800 text-xs rounded-full">
                {typeof item.badge === 'object' ? JSON.stringify(item.badge) : item.badge}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListModule;
